import { appModulesG4Fr } from './golf4App.fr.js';
// Frans (fr-FR), modulesApp: zelfde vorm als modulesApp.nl.ts. Modulenamen zonder lidwoord en
// zonder bijvoeglijk naamwoord dat moet overeenkomen ("le module {name}" is mannelijk).
export const appModulesFr = {
    ...appModulesG4Fr,
    title: 'Modules',
    intro: 'Choisis les fonctions que ta famille utilise. Désactiver n’efface rien : si tu réactives quelque chose, tout est encore là.',
    settingsBody: 'Active ou désactive des fonctions, comme déposer et récupérer',
    on: 'Activé',
    off: 'Désactivé',
    dependsOn: 'Nécessite aussi {names}.',
    offBecause: 'Désactivé ({names} est désactivé)',
    exampleA: 'Léa',
    exampleB: 'Hugo',
    holidaysIslamic: 'Aussi l’Aïd al-Fitr et l’Aïd al-Adha selon votre tradition.',
    blockedBy: 'Inactif, car {names} est désactivé.',
    alsoOff: 'Cela désactive aussi {names}.',
    notInPlan: 'Pas inclus dans ton abonnement.',
    settings: 'Réglages',
    /** WP3: toegankelijke naam van het tandwiel bij een module. */
    settingsOf: 'Réglages de {name}',
    // Golf 6b (0043): modules die niet bij de soort huishouden passen, en de soort zelf.
    showAll: 'Afficher tous les modules',
    showFewer: 'Seulement ce qui nous convient',
    hiddenNote: 'Les parties qui ne conviennent pas à votre type de foyer sont masquées.',
    typeLine: 'Type de foyer : {name}',
    typeChange: 'Modifier',
    toastOn: 'Module {name} activé',
    toastOff: 'Module {name} désactivé. Rien n’a été effacé.',
    toastOption: 'Enregistré',
    optionNeeds: 'Nécessite le module {name}.',
    onlyParents: 'Seul un parent peut changer ceci.',
    kioskNote: 'La tablette s’adapte en quelques secondes.',
    groups: {
        agenda: 'Agenda et déplacements',
        home: 'À la maison, ensemble',
        personal: 'Personnel',
        faith: 'Foi et tradition',
        board: 'Tableau et appli',
        care: 'Soins et famille',
    },
    groupCount: '{on} sur {total} activés',
    search: 'Rechercher un module',
    searchNone: 'Aucun module trouvé pour « {q} ».',
    options: 'Options ({n})',
    offTitle: 'Module {name} désactivé',
    offBody: 'Cette fonction est désactivée pour ta famille. Rien n’a été effacé.',
    offBodyChild: 'Cette fonction est désactivée. Demande à un parent de l’activer.',
    offAction: 'Aller à Modules',
    rides: {
        dropoff: '{name} dépose',
        pickup: '{name} récupère',
        both: '{name} dépose et récupère',
        whoDropoff: 'Qui dépose ?',
        whoPickup: 'Qui récupère ?',
        travel: '{minutes} min de trajet',
        travelWho: '{name} conduit · {minutes} min',
        /** 0056: smal blokje ná de afspraak (de weg terug). */
        travelBack: '{minutes} min retour',
    },
};
//# sourceMappingURL=modulesApp.fr.js.map